import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "theme"
const MODES = ["light", "dark", "system"]

export default class extends Controller {
  static targets = ["light", "dark", "system"]

  connect() {
    this.mql = window.matchMedia("(prefers-color-scheme: dark)")
    this.mqlHandler = () => {
      if (this.currentMode() === "system") this.applyTheme("system")
    }
    this.mql.addEventListener("change", this.mqlHandler)

    this.applyTheme(this.currentMode())
    this.reflectActive()
  }

  disconnect() {
    if (this.mql && this.mqlHandler) {
      this.mql.removeEventListener("change", this.mqlHandler)
    }
  }

  set(event) {
    const mode = event.params.mode
    if (!MODES.includes(mode)) return
    try {
      localStorage.setItem(STORAGE_KEY, mode)
    } catch (e) { /* private mode / disabled storage */ }
    this.applyTheme(mode)
    this.reflectActive()
    document.dispatchEvent(new CustomEvent("theme:changed", { detail: { mode, dark: this.isDark(mode) } }))
  }

  currentMode() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (MODES.includes(stored)) return stored
    } catch (e) { /* fall through */ }
    return "system"
  }

  isDark(mode) {
    return mode === "dark" || (mode === "system" && this.mql.matches)
  }

  applyTheme(mode) {
    document.documentElement.classList.toggle("dark", this.isDark(mode))
  }

  reflectActive() {
    const mode = this.currentMode()
    MODES.forEach((m) => {
      const target = this[`${m}Target`]
      if (target) target.setAttribute("aria-pressed", String(m === mode))
    })
  }
}
